import type { Ref } from "vue";

interface II18nForLocaleCheck {
  locale: Ref<string>;
  getLocaleMessage(locale: string): Record<string, unknown>;
}

/**
 * Checks whether a dot-notation i18n key resolves to a non-empty string in
 * the *current* locale's raw messages — without falling back to a fallback
 * locale. Use this when you need to distinguish "Opti has content for this
 * key" from "Opti has no content and we fell back to en.json".
 */
export function hasNonEmptyLocaleMessage(key: string, i18n: II18nForLocaleCheck): boolean {
  const msgs = i18n.getLocaleMessage(i18n.locale.value);
  const val = key.split(".").reduce<unknown>((obj, segment) => {
    return obj && typeof obj === "object" ? (obj as Record<string, unknown>)[segment] : undefined;
  }, msgs);
  return typeof val === "string" && val.trim().length > 0;
}
